/**
 * Styles To CSS Utility
 *
 * Utility function for converting object of styles to CSS string
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Convert object of styles to CSS string
 */
export const stylesToCSS = ( styles: Record< string, string > ): string => {
	return Object.entries( styles )
		.filter( ( [ , value ] ) => value && value !== '' )
		.map( ( [ property, value ] ) => `  ${ property }: ${ value };` )
		.join( '\n' );
};
